import React from "react";
import { Link } from "react-router-dom";
import '../../style_new.css';
const PageHeader = (props) => {
  return (
    
    <>
      <div class="container-fluid page-header py-5 mb-5 wow fadeIn"
        data-wow-delay="0.1s">
        <div class="container text-center py-5">
            <h1 class="display-4 text-white animated slideInDown mb-4">{props.name}</h1>
            <nav aria-label="breadcrumb animated slideInDown">
                <ol class="breadcrumb justify-content-center mb-0">
                    <li class="breadcrumb-item">
                    <a class="text-white" href="#">Home</a>
                    </li>
                    <li class="breadcrumb-item">
                    <a class="text-white" href="#">Pages</a>
                    </li>
                    <li class="breadcrumb-item text-primary active" aria-current="page">
                    {props.link}
                    </li>
                </ol>
            </nav>
        </div>
      </div>
    </>
  );
};
  
export default PageHeader;